<template>
  <v-card outlined class="pa-3">
    <v-card-title> Bundle Item - {{ bundleItem.name }} </v-card-title>
    <v-divider class="mb-3" />
    <v-form @submit.prevent="save()">
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <v-text-field v-model="form.min" outlined label="Min" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <v-text-field v-model="form.max" outlined label="Max" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <v-text-field
            v-model="form.default"
            outlined
            label="Standard"
          />
        </v-col>
        <v-col class="d-flex justify-end" cols="12">
          <v-btn type="submit" color="primary">
            Speichern
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
export default {
   name: 'BundleItemEdit',
   props: {
      bundleItem: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         form: this.$inertia.form({
            min: this.bundleItem.min,
            max: this.bundleItem.max,
            default: this.bundleItem.default
         })
      }
   },
   methods: {
      save () {
         this.form.patch(this.route('bundle_item.update', this.bundleItem.id), {
            preserveScroll: true,
            onSuccess: () => this.$emit('updated')
         })
      }
   }
}
</script>

<style></style>
